import type { TMessages } from '@/types/TMessages'

export const messages = {
  agreement: {
    text: 'Даю {agreement} на обработку своих персональных данных в соответствии c {policy}',
    agreement: 'Согласие',
    policy: 'Политикой обработки персональных данных',
  },
} as const satisfies TMessages
